import { Outlet, useNavigate } from 'react-router-dom'
import React from 'react'
import Error403 from '../ErrorPages/Error403'

const AdminRoutes = () => {

  const user = JSON.parse(localStorage.getItem('user'))
  return (
    user?.isAdmin ? <Outlet/> : <Error403/>
  )
}

export default AdminRoutes